import type { CalendarPostCard_PostData } from './fragments/CalendarPostCard_Post'

export const UNDATED_DRAFT_DRAG_SOURCE = 'calendarUndatedDraftsSidebar'
export const UNDATED_DRAFTS_SIDEBAR_DROP_TARGET =
  'calendarUndatedDraftsSidebarDropTarget'

export type UndatedDraftDragData = {
  type: 'post'
  source: typeof UNDATED_DRAFT_DRAG_SOURCE
  post: CalendarPostCard_PostData
  label: string
}

export type UndatedDraftsSidebarDropData = {
  type: typeof UNDATED_DRAFTS_SIDEBAR_DROP_TARGET
  label: string
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function isUndatedDraftDragData(
  data: unknown,
): data is UndatedDraftDragData {
  return (
    isRecord(data) &&
    data.type === 'post' &&
    data.source === UNDATED_DRAFT_DRAG_SOURCE &&
    isRecord(data.post) &&
    typeof data.post.id === 'string' &&
    typeof data.label === 'string'
  )
}

export function isUndatedDraftsSidebarDropData(
  data: unknown,
): data is UndatedDraftsSidebarDropData {
  return (
    isRecord(data) &&
    data.type === UNDATED_DRAFTS_SIDEBAR_DROP_TARGET &&
    typeof data.label === 'string'
  )
}
